module.exports = __webpack_public_path__ + "img/eight4Green.5eaff66a.jpg";